import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { initialCampaignState } from "./campaign.state";
import { getCampaigns, getCampaign } from "./campaign.thunk";
import type { CampaignDetailData } from "./campaign.types";

export const campaignSlice = createSlice({
  name: "campaign",
  initialState: initialCampaignState,
  reducers: {
    resetCampaigns: (state) => {
      state.campaigns = [];
      state.campaignsStatus = "idle";
      state.campaignsError = null;
      state.campaignsPagination = null;
    },
    resetCampaign: (state) => {
      state.campaign = null;
      state.campaignStatus = "idle";
      state.campaignError = null;
      state.items = [];
      state.pagination = null;
    },
    /** SSR/ISR verisini mount'ta Redux'a yükler. Filtresiz ilk sayfaya karşılık
     *  gelir; kullanıcı filtre uygulayınca getCampaign thunk'ı devralır. */
    setInitialCampaign: (
      state,
      action: PayloadAction<CampaignDetailData>,
    ) => {
      state.campaign = action.payload.campaign;
      state.items = action.payload.items;
      state.pagination = action.payload.pagination;
      state.campaignStatus = "success";
      state.campaignError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // ==================== GET CAMPAIGNS LIST ====================
      .addCase(getCampaigns.pending, (state, action) => {
        state.campaignsStatus = "loading";
        state.campaignsError = null;
        if (!action.meta.arg.page || action.meta.arg.page === 1) {
          state.campaigns = [];
          state.campaignsPagination = null;
        }
      })
      .addCase(getCampaigns.fulfilled, (state, action) => {
        state.campaignsStatus = "success";
        state.campaignsPagination = action.payload.data.pagination;
        if (action.payload.page === 1) {
          state.campaigns = action.payload.data.items;
        } else {
          state.campaigns.push(...action.payload.data.items);
        }
      })
      .addCase(getCampaigns.rejected, (state, action) => {
        state.campaignsStatus = "error";
        state.campaignsError = action.payload ?? "Kampanyalar yüklenemedi.";
      })

      // ==================== GET CAMPAIGN DETAIL ====================
      .addCase(getCampaign.pending, (state, action) => {
        state.campaignStatus = "loading";
        state.campaignError = null;

        if (!action.meta.arg.page || action.meta.arg.page === 1) {
          state.items = [];
          state.pagination = null;
        }
      })
      .addCase(getCampaign.fulfilled, (state, action) => {
        state.campaignStatus = "success";
        state.campaign = action.payload.data.campaign;
        state.pagination = action.payload.data.pagination;

        const isFirstPage = action.payload.data.pagination.current_page === 1;

        if (isFirstPage) {
          state.items = action.payload.data.items;
        } else {
          state.items.push(...action.payload.data.items);
        }
      })
      .addCase(getCampaign.rejected, (state, action) => {
        state.campaignStatus = "error";
        state.campaignError = action.payload ?? "Kampanya yüklenemedi.";
      });
  },
});

export const { resetCampaigns, resetCampaign, setInitialCampaign } =
  campaignSlice.actions;
export default campaignSlice.reducer;